/**
 * WordPress dependencies.
 */
import { Component } from '@wordpress/element';
import { Flex, FlexItem, FlexBlock } from '@wordpress/components';
import {
	RichText,
} from '@wordpress/block-editor';

import { __ } from '@wordpress/i18n';

import Inspector from './inspector';
import BaseWrapper from '../../components/base-wrapper';

class edit extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			locationState: '',
		};
		this.updateState = this.updateState.bind( this );
	}

	updateState( data ) {
		this.setState( ( prevValue ) => {
			return {
				...prevValue,
				...data,
			};
		} );
	}

	componentDidUpdate() {
		const {
			attributes,
			isSelected,
			setAttributes,
		} = this.props;
		const { location } = attributes;
		if ( ! isSelected && '' === location ) {
			setAttributes( {
				pinned: false,
			} );
		}
	}

	render() {
		const {
			attributes,
			isSelected,
			setAttributes,
			className,
		} = this.props;
		const { daysLabel, hoursLabel, minutesLabel, secondsLabel, showDays, showHour, showMinute, showSecond, showLabel } = attributes;

		return <div className={ className }>
			{ isSelected && <Inspector { ...this.props } /> }
			<BaseWrapper { ...this.props }>
				<Flex>
					{ showDays && <FlexBlock>
						<FlexItem>00</FlexItem>
						{ showLabel && <FlexItem>
							<RichText
								tagName="span"
								value={ daysLabel }
								allowedFormats={ [ 'core/bold', 'core/italic' ] }
								onChange={ ( content ) => setAttributes( { daysLabel: content } ) }
								placeholder={ __( 'Days' ) }
							/>
						</FlexItem> }
					</FlexBlock> }
					{ showHour && <FlexBlock>
						<FlexItem>00</FlexItem>
						{ showLabel && <FlexItem>
							<RichText
								tagName="span"
								value={ minutesLabel }
								allowedFormats={ [ 'core/bold', 'core/italic' ] }
								onChange={ ( content ) => setAttributes( { minutesLabel: content } ) }
								placeholder={ __( 'Hours' ) }
							/>
						</FlexItem> }
					</FlexBlock> }
					{ showMinute && <FlexBlock>
						<FlexItem>00</FlexItem>
						{ showLabel && <FlexItem>
							<RichText
								tagName="span"
								value={ secondsLabel }
								allowedFormats={ [ 'core/bold', 'core/italic' ] }
								onChange={ ( content ) => setAttributes( { secondsLabel: content } ) }
								placeholder={ __( 'Hours' ) }
							/>
						</FlexItem> }
					</FlexBlock> }
					{ showSecond && <FlexBlock>
						<FlexItem>00</FlexItem>
						{ showLabel && <FlexItem>
							<RichText
								tagName="span"
								value={ hoursLabel }
								allowedFormats={ [ 'core/bold', 'core/italic' ] }
								onChange={ ( content ) => setAttributes( { hoursLabel: content } ) }
								placeholder={ __( 'Hours' ) }
							/>
						</FlexItem> }
					</FlexBlock> }
				</Flex>
			</BaseWrapper>
		</div>;
	}
}

export default edit;
